import { graphql } from 'react-relay';

import createMutation from '../relay/createMutation';

const mutation = graphql`
  mutation SendPushNotificationMutation(
    $input: SendPushNotificationMutationInput!
  ) {
    sendPushNotification(input: $input) {
      clientMutationId
    }
  }
`;

export default variables => createMutation(mutation)(variables);



// WEBPACK FOOTER //
// ./src/mutations/SendPushNotificationMutation.js